// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"70d4bc6c-168":"bde3a67b94a9153c5724","70d4bc6c-452":"14523192749b7e0b9eee","70d4bc6c-379":"d8fc7b6c770ba8a4df4b","70d4bc6c-83":"edc38d145d0d28ee316a"}[chunkId] + ".js";
};